import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import {withRouter} from "react-router-dom";

import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";

import LookDropdown from "../../../ui/lookDropdown";
import {setPaymentInfo} from "../../../../../actions/paymentFunctions";
import {ROUTES} from "../../../../../routes";


const GroheCartPaymentDropdown = (props) => {

  const {cardInfo, intl, history} = props;

  const changePaymentClick = () => {
    history.push(ROUTES.cartPayment);
  }

  const paymentSelect = cardInfo.cardNumber ? [{
    text: intl.formatMessage({id: "grohe.cart.billing.payment.cardEnding"}) + " " + cardInfo.cardNumber.substr(cardInfo.cardNumber.length - 4),
    value: 0,
  }] : [];

  return (
    <Fragment>
      <h2 className="gc-header__title">
        <FormattedMessage id="grohe.cart.billing.payment.title"/>
      </h2>
      <p className="gc-header__sub-title">
        <FormattedMessage id="grohe.cart.billing.payment.subTitle"/>
      </p>
      <LookDropdown className="gc-select"
                    textOnly={true}
                    selectLabel={intl.formatMessage({id: "grohe.cart.billing.payment.title"}) + ":"}
                    selectItems={paymentSelect}
                    selectedItem={paymentSelect[0]}
                    selectItemClick={(selectItem, selectItemIndex) => setPaymentInfo(selectItemIndex)}/>
      <div className="gc-content__change">
        <Button className="look-button--no-bg look-button--text look-button--no-transform nowrap"
                startIcon={<EditIcon/>}
                onClick={changePaymentClick}>
          <FormattedMessage id={
            cardInfo.cardNumber ? "grohe.cart.billing.payment.changePaymentMethod" : "grohe.cart.billing.payment.addNewPaymentMethod"
          }/>
        </Button>
      </div>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {cardInfo} = store.paymentState;

  return {
    isMobile,
    cardInfo,
  };
};

const mapDispatchToProps = {
  setPaymentInfo,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(GroheCartPaymentDropdown)
  )
)
